const Misc = {
    callLater : function(cb, delay){
        if(delay === undefined){delay = 0;}
        return setTimeout(cb, delay);
    },

    callEvery : function(cb, delay){
        if(delay === undefined){delay = 0;}
        return setInterval(cb, delay);
    },

    scrollToTop : function(){
        let scrollDuration = 250;
        let scrollStep = -window.scrollY / (scrollDuration / 15);
        let scrollInterval = setInterval(function(){
            if ( window.scrollY != 0 ) {
                window.scrollBy( 0, scrollStep );
            }
            else{
                clearInterval(scrollInterval);
            }
        },15);
    },

    scrollLeftBy : function($elm, val, cb){
        /*const toScroll = $elm.scrollLeft() + val;
        $elm.stop(true, true).animate({
            scrollLeft: toScroll
        }, 250);
        Misc.callLater(cb, 250);*/
    },

    isMobile(){
        return window.innerWidth < 600;
    },

    scrollToElm : function($elm){
        if(Misc.scrolling)
            return;
        Misc.scrolling = true;
        if($elm.length > 0){
            scrollIt($elm[0]);
        }
        Misc.callLater(function(){
            Misc.scrolling = false;
        }, 250);
    },

    isVisibleOnScreen(sel){
        let $win = $(window);
        let $elm = $(sel);
        let docViewTop = $win.scrollTop();
        let docViewBottom = docViewTop + $win.height();
        let elemTop = $elm.offset().top;
        let elemBottom = elemTop;// + $elm.height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    },

    isMostlyVisibleOnScreen(sel){
        let $win = $(window);
        let $elm = $(sel);
        let docViewTop = $win.scrollTop();
        let docViewBottom = docViewTop + $win.height();
        let elemTop = $elm.offset().top;
        let elemBottom = elemTop + $elm.height() / 2;
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    },

    hasScroll($elm, cb){
        if($elm && $elm.length > 0){
            if(!Misc.scrollCounter)
                Misc.scrollCounter = 0;
            let scrollHeight = $elm[0].scrollHeight;
            let clientHeight = $elm[0].clientHeight;
            if(clientHeight > 0 && Misc.scrollCounter > 0){
                cb(clientHeight < scrollHeight);
                Misc.scrollCounter = 0;
            }
            else if(Misc.scrollCounter < 10){
                Misc.scrollCounter++
                Misc.callLater(function(){
                    Misc.hasScroll($elm, cb);
                }, 100);
            }
            else{
                cb(false);
                Misc.scrollCounter = 0
            }
        }
        else{
            cb(false);
            Misc.scrollCounter = 0
        }
    },

    setOverlay(showOverlay, showLoader){
        let $overlay = $("#overlay");
        let $loader = $(".loader", $overlay);
        if(showOverlay){
            $overlay.removeClass("hidden");
            $("#sections").addClass("blur");
            $("footer.app-footer").addClass("blur");
            $("header.main-header nav").addClass("blur");
            $("body").addClass("no-scroll");
        }
        else{
            $overlay.addClass("hidden");
            $("#sections").removeClass("blur");
            $("footer.app-footer").removeClass("blur");
            $("header.main-header nav").removeClass("blur");
            $("body").removeClass("no-scroll");
        }
        if(showLoader){
            $loader.addClass("active").removeClass("hidden");
        }
        else {
            $loader.removeClass("active").addClass("hidden");
        }
    },
    randomNumber : function (min, max) {
        if(!min)
            min = 0;
        if(!max)
            max = 1000000000000;
        return Math.ceil(Math.random() * (max - min) + min);
    },

    isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },

    sort(list, sortOn, reverse){
        if(list && list.length > 0){
            let sortStr = function(a,b){
                if (a[sortOn] < b[sortOn])
                    return -1;
                if (a[sortOn] > b[sortOn])
                    return 1;
                return 0;
            };
            let sortNum = function(a,b){
                return b[sortOn] - a[sortOn];
            };

            if(list && list.length > 0) {
                if (this.isNumber(list[0][sortOn]))
                    list.sort(sortNum);
                else
                    list.sort(sortStr);
            }
            if(reverse){
                list.reverse();
            }
        }
    },

    cloneAry(list){
        return list.slice(0);
    },

    cloneObj(obj){
        if(obj)
            return $.extend({}, obj);
        return null;
    },

    convertObjToArray(obj){
        return $.map(obj, function(el) { return el });
    },

    getOne(list){
        let idx = Misc.randomNumber(0, list.length - 1);
        return list[idx];
    },

    joinArray(ary1, ary2){
        return (ary1 && ary2) ? ary1.concat(ary2) : ary1;
    },

    shadeColor(color, percent) {
        if(!color)
            color = "454545";
        let R = parseInt(color.substring(1,3),16);
        let G = parseInt(color.substring(3,5),16);
        let B = parseInt(color.substring(5,7),16);
        let rgbColor = "rgba("+ R + "," + G + "," + B +", " + percent + ")";//rgba(0, 0, 0, 0.5);
        return rgbColor;
    }
};

module.exports = Misc;

function scrollIt(destination, duration = 200, easing = 'linear', callback) {

    const easings = {
        linear(t) {
            return t;
        },
        easeInQuad(t) {
            return t * t;
        },
        easeOutQuad(t) {
            return t * (2 - t);
        },
        easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic(t) {
            return t * t * t;
        },
        easeOutCubic(t) {
            return (--t) * t * t + 1;
        },
        easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart(t) {
            return t * t * t * t;
        },
        easeOutQuart(t) {
            return 1 - (--t) * t * t * t;
        },
        easeInOutQuart(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
        },
        easeInQuint(t) {
            return t * t * t * t * t;
        },
        easeOutQuint(t) {
            return 1 + (--t) * t * t * t * t;
        },
        easeInOutQuint(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
        }
    };

    const start = window.pageYOffset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
    const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
    var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

    destinationOffsetToScroll = Math.max(0, destinationOffsetToScroll - 76);

    if ('requestAnimationFrame' in window === false) {
        window.scroll(0, destinationOffsetToScroll);
        if (callback) {
            callback();
        }
        return;
    }

    function scroll() {
        const now = 'now' in window.performance ? performance.now() : new Date().getTime();
        const time = Math.min(1, ((now - startTime) / duration));
        const timeFunction = easings[easing](time);
        window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

        if (window.pageYOffset === destinationOffsetToScroll) {
            if (callback) {
                callback();
            }
            return;
        }

        requestAnimationFrame(scroll);
    }

    scroll();
};


// WEBPACK FOOTER //
// ./src/control/util/Misc.js